export default __webpack_public_path__ + "static/disconected-24667ca99fffdb535b929e5b797e1543.svg";